export enum DocumentType{
    ABB = "ABB",
    Reports = "Reports",
    Uploaded = "Uploaded"
}